// extracted by mini-css-extract-plugin
export default {"container":"Letter_container__1HUgh","inner":"Letter_inner__LCIqA","item":"Letter_item__qPrL2"};